var _style, _ellipse, _path, _g, _rect, _rect2, _g2, _path2, _rect3, _rect4, _rect5, _g3, _g4, _g5, _g6, _g7, _rect6, _path3, _path4, _path5, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderconstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFD9AC;}\n\t.st1{fill:#997C4F;}\n\t.st2{fill:#495E57;}\n\t.st3{fill:#ECEFF1;}\n\t.st4{fill:#333333;}\n\t.st5{fill:#EE9972;}\n\t.st6{fill:#484F58;}\n\t.st7{fill:#F4CE14;}\n\t.st8{fill:#C4B290;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 255.25,
    cy: 358.34,
    rx: 147,
    ry: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.83,348.16c-7.49,0-13.66,5.6-14.58,12.84h29.17C360.5,353.76,354.33,348.16,346.83,348.16z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.74,335.57h-43.42c-1.43,0-2.59,1.16-2.59,2.59c0,1.43,1.16,2.59,2.59,2.59h43.42 c1.43,0,2.59-1.16,2.59-2.59C172.33,336.73,171.17,335.57,169.74,335.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.55,298.66c-0.2-0.56-0.73-0.93-1.33-0.93h-4.98c-0.6,0-1.14,0.38-1.33,0.95l-14.01,40.08h36.25 L151.55,298.66z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "141.32,306.09 139.11,312.42 156.57,312.42 154.26,306.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "135.69,322.22 133.47,328.56 162.44,328.56 160.14,322.22  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 148.87,
    className: "st3",
    width: 13.6,
    height: 212.31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 360.86,
    y: 148.87,
    className: "st4",
    width: 4.58,
    height: 212.31
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.03,199.34h-8.48c-0.55,0-0.99-0.44-1-0.99c-0.05-3.72-3.11-6.75-6.83-6.75c-1.9,0-3.74,0.81-5.04,2.23 c-0.27,0.29-0.68,0.4-1.06,0.27c-0.38-0.13-0.64-0.46-0.67-0.86c-0.5-5.64-5.15-9.9-10.81-9.9c-5.85,0-10.72,4.77-10.85,10.62 c-0.01,0.46-0.33,0.86-0.79,0.95c-0.45,0.1-0.91-0.12-1.11-0.54c-1.57-3.23-4.77-5.23-8.35-5.23c-5.07,0-9.24,4.13-9.29,9.2 c-0.01,0.55-0.45,0.99-1,0.99h-7.5c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h6.55c0.56-5.71,5.4-10.19,11.24-10.19 c3.39,0,6.5,1.48,8.62,4c1.39-5.6,6.5-9.8,12.48-9.8c6.08,0,11.16,4.13,12.51,9.87c1.48-1.04,3.25-1.61,5.07-1.61 c4.48,0,8.22,3.39,8.76,7.74h7.55c0.55,0,1,0.45,1,1C170.03,198.89,169.58,199.34,169.03,199.34z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.83,343.5c-7.49,0-13.66,5.6-14.58,12.84h29.17C180.5,349.1,174.33,343.5,166.83,343.5z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151.04,
    y: 148.87,
    className: "st3",
    width: 13.6,
    height: 212.31
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 148.87,
    className: "st4",
    width: 4.58,
    height: 212.31
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 135.23,
    y: 158.28,
    className: "st3",
    width: 247.87,
    height: 120.27
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.97,213.01v-10.86h3.83c1.22,0,2.17,0.3,2.86,0.9c0.68,0.6,1.02,1.46,1.02,2.56 c0,1.09-0.34,1.94-1.02,2.54c-0.68,0.6-1.64,0.9-2.86,0.9h-1.84v3.95H207.97z M209.96,207.34h1.84c0.61,0,1.08-0.16,1.39-0.48 c0.31-0.32,0.47-0.74,0.47-1.24c0-0.51-0.16-0.93-0.47-1.26c-0.31-0.33-0.78-0.49-1.39-0.49h-1.84V207.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.54,213.01l3.7-10.86h2.48l3.55,10.86h-2.08l-0.75-2.34h-4.03l-0.77,2.34H216.54z M219.91,209.18h3.06 l-1.52-4.67L219.91,209.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.16,213.25c-0.89,0-1.69-0.23-2.4-0.7c-0.71-0.47-1.28-1.12-1.7-1.96c-0.42-0.84-0.63-1.82-0.63-2.94 c0-0.89,0.13-1.68,0.39-2.38c0.26-0.7,0.62-1.3,1.08-1.8c0.46-0.5,1.01-0.87,1.63-1.13c0.62-0.26,1.3-0.39,2.03-0.39 c1.02,0,1.87,0.22,2.56,0.66s1.23,1.14,1.61,2.08l-2.02,0.47c-0.28-0.46-0.61-0.82-0.98-1.06c-0.37-0.24-0.79-0.36-1.26-0.36 c-0.54,0-1.02,0.16-1.46,0.47c-0.44,0.32-0.79,0.77-1.05,1.35c-0.26,0.59-0.39,1.28-0.39,2.09c0,0.76,0.12,1.42,0.35,1.99 c0.23,0.57,0.56,1.01,0.97,1.33c0.42,0.32,0.9,0.48,1.46,0.48c0.47,0,0.89-0.1,1.26-0.31c0.37-0.21,0.66-0.51,0.88-0.9 c0.21-0.39,0.32-0.86,0.32-1.41h0.44c0,0.9-0.11,1.69-0.32,2.35c-0.21,0.66-0.55,1.18-1,1.54 C233.45,213.07,232.87,213.25,232.16,213.25z M235.08,213.01l-0.28-2.39v-1.87l-2.44-0.05v-1.25h4.33v5.57H235.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.51,213.01v-10.86h6.98v1.71h-5v2.86h4.7v1.71h-4.7v2.86h5v1.72H239.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M253.41,202.15h1.97v6.76c0,0.89,0.23,1.54,0.68,1.93s1.04,0.59,1.74,0.59c0.71,0,1.3-0.2,1.75-0.59 c0.45-0.4,0.68-1.04,0.68-1.93v-6.76h1.97v6.76c0,0.91-0.18,1.7-0.53,2.34s-0.85,1.14-1.51,1.48c-0.66,0.34-1.44,0.51-2.36,0.51 c-0.92,0-1.71-0.17-2.36-0.51c-0.66-0.34-1.16-0.83-1.51-1.48s-0.53-1.43-0.53-2.34V202.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.09,202.15h2.16l4.94,7.75h-0.15v-7.75h1.97v10.86H272l-5.25-8.22h0.32v8.22h-1.97V202.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.12,202.15h3.51c1.1,0,2.07,0.22,2.9,0.67c0.83,0.44,1.48,1.07,1.94,1.89s0.69,1.78,0.69,2.89 c0,1.1-0.23,2.05-0.69,2.87s-1.11,1.44-1.94,1.89c-0.83,0.45-1.8,0.67-2.9,0.67h-3.51V202.15z M279.09,203.95v7.3h1.54 c0.7,0,1.31-0.16,1.82-0.48s0.9-0.75,1.18-1.3c0.28-0.55,0.41-1.17,0.41-1.87c0-0.71-0.14-1.34-0.41-1.88 c-0.28-0.55-0.67-0.98-1.18-1.29c-0.51-0.32-1.12-0.47-1.82-0.47H279.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M288.59,213.01v-10.86h6.98v1.71h-5v2.86h4.7v1.71h-4.7v2.86h5v1.72H288.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.42,213.01v-10.86h4.02c1.3,0,2.3,0.3,2.99,0.91c0.69,0.61,1.04,1.41,1.04,2.42 c0,0.99-0.35,1.78-1.04,2.39c-0.69,0.61-1.69,0.91-2.99,0.91h-2.04v4.23H298.42z M300.39,207.46h1.84c0.73,0,1.27-0.17,1.65-0.5 c0.37-0.33,0.56-0.76,0.56-1.29c0-0.54-0.17-0.98-0.51-1.31s-0.84-0.5-1.5-0.5h-2.04V207.46z M304.29,213.01l-2.88-5.09h2.11 l3.35,5.09H304.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.72,235.21c-0.95,0-1.78-0.23-2.49-0.68s-1.25-1.11-1.64-1.95c-0.39-0.85-0.59-1.87-0.59-3.05 c0-1.23,0.2-2.26,0.61-3.09c0.4-0.83,0.96-1.46,1.67-1.89s1.52-0.64,2.44-0.64c1.27,0,2.25,0.31,2.97,0.92 c0.71,0.61,1.17,1.41,1.37,2.39l-2.11,0.38c-0.17-0.57-0.45-1.03-0.83-1.38c-0.38-0.35-0.84-0.53-1.4-0.53 c-0.49,0-0.92,0.14-1.31,0.42c-0.39,0.28-0.7,0.71-0.93,1.28c-0.23,0.57-0.35,1.28-0.35,2.13c0,0.8,0.1,1.49,0.31,2.07 c0.2,0.58,0.5,1.03,0.88,1.34s0.85,0.47,1.41,0.47c0.71,0,1.26-0.19,1.64-0.56s0.58-0.86,0.58-1.44h2.11 c0,0.81-0.17,1.5-0.52,2.06c-0.35,0.57-0.85,1-1.49,1.3C204.39,235.06,203.62,235.21,202.72,235.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.52,235.21c-0.96,0-1.82-0.21-2.56-0.64c-0.74-0.42-1.32-1.06-1.74-1.9s-0.63-1.89-0.63-3.14 c0-1.27,0.21-2.32,0.63-3.16s1-1.46,1.74-1.87c0.74-0.41,1.59-0.62,2.56-0.62c0.97,0,1.83,0.21,2.57,0.63 c0.74,0.42,1.32,1.05,1.74,1.89c0.42,0.84,0.63,1.88,0.63,3.12c0,1.27-0.21,2.32-0.63,3.16c-0.42,0.84-1,1.47-1.74,1.89 C215.35,235,214.49,235.21,213.52,235.21z M213.52,233.42c0.89,0,1.59-0.33,2.11-1c0.52-0.67,0.78-1.63,0.78-2.9 c0-1.22-0.26-2.16-0.78-2.84c-0.52-0.67-1.23-1.01-2.11-1.01c-0.87,0-1.57,0.34-2.09,1.02s-0.79,1.63-0.79,2.85 c0,1.25,0.26,2.22,0.79,2.88S212.65,233.42,213.52,233.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.76,224.12h2.16l4.94,7.75h-0.15v-7.75h1.97v10.86h-2.01l-5.25-8.22h0.32v8.22h-1.97V224.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.57,235.21c-0.75,0-1.45-0.13-2.08-0.39c-0.63-0.26-1.15-0.66-1.54-1.2c-0.39-0.54-0.6-1.22-0.63-2.04 h1.94c0,0.42,0.1,0.76,0.31,1.03c0.21,0.27,0.48,0.47,0.83,0.6s0.73,0.2,1.15,0.2c0.4,0,0.76-0.05,1.08-0.16 c0.31-0.11,0.56-0.26,0.74-0.46c0.18-0.2,0.27-0.43,0.27-0.71c0-0.36-0.11-0.65-0.33-0.85c-0.22-0.21-0.57-0.4-1.06-0.57 l-2.14-0.85c-0.84-0.33-1.48-0.71-1.92-1.15c-0.45-0.44-0.67-1.03-0.67-1.8c0-0.88,0.35-1.6,1.05-2.14 c0.7-0.55,1.67-0.82,2.92-0.82c1.22,0,2.16,0.28,2.82,0.85c0.66,0.57,1.04,1.35,1.13,2.36h-1.94c-0.07-0.43-0.27-0.77-0.59-1.03 s-0.79-0.39-1.42-0.39c-0.56,0-1,0.12-1.32,0.35c-0.32,0.23-0.48,0.52-0.48,0.87c0,0.3,0.1,0.54,0.31,0.72s0.52,0.34,0.95,0.51 l2.38,0.92c0.8,0.31,1.42,0.71,1.85,1.18c0.43,0.47,0.64,1.07,0.64,1.78c0,0.65-0.17,1.22-0.49,1.69 c-0.33,0.48-0.81,0.85-1.44,1.11C238.24,235.08,237.47,235.21,236.57,235.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242,225.82v-1.71h8.7v1.71h-3.81l0.44-0.45v9.6h-1.97v-9.6l0.44,0.45H242z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M252.35,234.98v-10.86h4.02c1.3,0,2.3,0.3,2.99,0.91c0.69,0.61,1.04,1.41,1.04,2.42 c0,0.99-0.35,1.78-1.04,2.39c-0.69,0.61-1.69,0.91-2.99,0.91h-2.04v4.23H252.35z M254.32,229.42h1.84c0.73,0,1.27-0.17,1.65-0.5 c0.37-0.33,0.56-0.76,0.56-1.29c0-0.54-0.17-0.98-0.51-1.31s-0.84-0.5-1.5-0.5h-2.04V229.42z M258.22,234.98l-2.88-5.09h2.11 l3.35,5.09H258.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.95,224.12h1.97v6.76c0,0.89,0.23,1.54,0.68,1.93s1.04,0.59,1.74,0.59c0.71,0,1.3-0.2,1.75-0.59 c0.45-0.4,0.68-1.04,0.68-1.93v-6.76h1.97v6.76c0,0.91-0.18,1.7-0.53,2.34s-0.85,1.14-1.51,1.48c-0.66,0.34-1.44,0.51-2.36,0.51 c-0.92,0-1.71-0.17-2.36-0.51c-0.66-0.34-1.16-0.83-1.51-1.48s-0.53-1.43-0.53-2.34V224.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278.61,235.21c-0.95,0-1.78-0.23-2.49-0.68s-1.25-1.11-1.64-1.95c-0.39-0.85-0.59-1.87-0.59-3.05 c0-1.23,0.2-2.26,0.61-3.09c0.4-0.83,0.96-1.46,1.67-1.89s1.52-0.64,2.44-0.64c1.27,0,2.25,0.31,2.97,0.92 c0.71,0.61,1.17,1.41,1.37,2.39l-2.11,0.38c-0.17-0.57-0.45-1.03-0.83-1.38c-0.38-0.35-0.84-0.53-1.4-0.53 c-0.49,0-0.92,0.14-1.31,0.42c-0.39,0.28-0.7,0.71-0.93,1.28c-0.23,0.57-0.35,1.28-0.35,2.13c0,0.8,0.1,1.49,0.31,2.07 c0.2,0.58,0.5,1.03,0.88,1.34s0.85,0.47,1.41,0.47c0.71,0,1.26-0.19,1.64-0.56s0.58-0.86,0.58-1.44h2.11 c0,0.81-0.17,1.5-0.52,2.06c-0.35,0.57-0.85,1-1.49,1.3C280.28,235.06,279.51,235.21,278.61,235.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.81,225.82v-1.71h8.7v1.71h-3.81l0.44-0.45v9.6h-1.97v-9.6l0.44,0.45H283.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.16,234.98v-10.86h1.97v10.86H294.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.4,235.21c-0.96,0-1.82-0.21-2.56-0.64c-0.74-0.42-1.32-1.06-1.74-1.9s-0.63-1.89-0.63-3.14 c0-1.27,0.21-2.32,0.63-3.16s1-1.46,1.74-1.87c0.74-0.41,1.59-0.62,2.56-0.62c0.97,0,1.83,0.21,2.57,0.63 c0.74,0.42,1.32,1.05,1.74,1.89c0.42,0.84,0.63,1.88,0.63,3.12c0,1.27-0.21,2.32-0.63,3.16c-0.42,0.84-1,1.47-1.74,1.89 C305.23,235,304.37,235.21,303.4,235.21z M303.4,233.42c0.89,0,1.59-0.33,2.11-1c0.52-0.67,0.78-1.63,0.78-2.9 c0-1.22-0.26-2.16-0.78-2.84c-0.52-0.67-1.23-1.01-2.11-1.01c-0.87,0-1.57,0.34-2.09,1.02s-0.79,1.63-0.79,2.85 c0,1.25,0.26,2.22,0.79,2.88S302.53,233.42,303.4,233.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.64,224.12h2.16l4.94,7.75h-0.15v-7.75h1.97v10.86h-2.01l-5.25-8.22h0.32v8.22h-1.97V224.12z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.24,370.97h-51.69c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h51.69c1.7,0,3.08-1.38,3.08-3.08 S220.94,370.97,219.24,370.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.59,327.03c-0.24-0.66-0.87-1.11-1.58-1.11h-5.92c-0.72,0-1.35,0.45-1.59,1.13l-16.68,47.71h43.15 L197.59,327.03z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "185.41,335.88 182.77,343.42 203.55,343.42 200.81,335.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "178.69,355.08 176.06,362.62 210.55,362.62 207.8,355.08  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.34,375.55l27.97-43.46c0.92-1.43,0.51-3.34-0.92-4.26s-3.34-0.51-4.26,0.92l-27.97,43.46 c-0.92,1.43-0.51,3.34,0.92,4.26S293.42,376.98,294.34,375.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343,381.13c0.69,0.16,1.4-0.14,1.79-0.73l3.21-4.98c0.39-0.6,0.35-1.38-0.09-1.95l-31.1-39.85l-23.35,36.28 L343,381.13z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "342.15,366.1 337.24,359.8 325.99,377.28 333.82,379.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "329.64,350.06 324.73,343.77 306.06,372.76 313.88,374.54  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.23,
    y: 158.28,
    className: "st7",
    width: 247.87,
    height: 18.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "142.65,158.28 135.23,168.63 135.23,176.75 142.28,176.75 155.52,158.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "168.77,176.75 182.02,158.28 169.15,158.28 155.9,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "195.27,176.75 208.51,158.28 195.64,158.28 182.4,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "221.76,176.75 235.01,158.28 222.14,158.28 208.89,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "248.26,176.75 261.5,158.28 248.63,158.28 235.39,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "274.75,176.75 288,158.28 275.13,158.28 261.88,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "301.25,176.75 314.49,158.28 301.62,158.28 288.38,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "327.74,176.75 340.99,158.28 328.12,158.28 314.87,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "354.23,176.75 367.48,158.28 354.61,158.28 341.36,176.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "380.73,176.75 383.1,173.45 383.1,158.28 381.11,158.28 367.86,176.75  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.23,
    y: 260.43,
    className: "st7",
    width: 247.87,
    height: 18.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "142.65,260.43 135.23,270.78 135.23,278.9 142.28,278.9 155.52,260.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "168.77,278.9 182.02,260.43 169.15,260.43 155.9,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "195.27,278.9 208.51,260.43 195.64,260.43 182.4,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "221.76,278.9 235.01,260.43 222.14,260.43 208.89,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "248.26,278.9 261.5,260.43 248.63,260.43 235.39,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "274.75,278.9 288,260.43 275.13,260.43 261.88,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "301.25,278.9 314.49,260.43 301.62,260.43 288.38,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "327.74,278.9 340.99,260.43 328.12,260.43 314.87,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "354.23,278.9 367.48,260.43 354.61,260.43 341.36,278.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "380.73,278.9 383.1,275.6 383.1,260.43 381.11,260.43 367.86,278.9  "
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.67,
    y: 158.28,
    className: "st4",
    width: 4.86,
    height: 120.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.25,348.34c-9.33,0-17.02,6.98-18.17,16h36.34C168.27,355.32,160.58,348.34,151.25,348.34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M360.58,354.34c-9.33,0-17.02,6.98-18.17,16h36.34C377.6,361.32,369.92,354.34,360.58,354.34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M132.17,351.5c-7.49,0-13.66,5.6-14.58,12.84h29.17C145.83,357.1,139.66,351.5,132.17,351.5z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M345.03,143.34h-27.5c-0.55,0-0.99-0.44-1-0.99c-0.05-5.08-4.22-9.2-9.29-9.2c-3.58,0-6.77,2-8.35,5.23 c-0.2,0.41-0.66,0.64-1.11,0.54c-0.45-0.1-0.78-0.49-0.79-0.95c-0.13-5.86-4.99-10.62-10.85-10.62c-5.67,0-10.32,4.26-10.81,9.9 c-0.03,0.39-0.3,0.73-0.67,0.86c-0.38,0.13-0.79,0.02-1.06-0.27c-1.3-1.41-3.13-2.23-5.04-2.23c-3.72,0-6.79,3.03-6.83,6.75 c-0.01,0.55-0.45,0.99-1,0.99h-8.48c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h7.55c0.55-4.35,4.29-7.74,8.76-7.74 c1.82,0,3.6,0.57,5.07,1.61c1.34-5.74,6.43-9.87,12.51-9.87c5.98,0,11.09,4.2,12.48,9.8c2.11-2.51,5.22-4,8.62-4 c5.83,0,10.68,4.49,11.24,10.19h26.56c0.55,0,1,0.45,1,1C346.03,142.89,345.58,143.34,345.03,143.34z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.68,113.29h-21.34c-0.55,0-0.99-0.44-1-0.99c-0.07-7.7-6.39-13.96-14.09-13.96 c-5.42,0-10.28,3.04-12.66,7.94c-0.2,0.42-0.66,0.64-1.11,0.54c-0.45-0.1-0.78-0.49-0.79-0.95c-0.19-8.84-7.54-16.04-16.38-16.04 c-8.56,0-15.57,6.42-16.32,14.94c-0.03,0.39-0.3,0.73-0.67,0.86c-0.38,0.13-0.79,0.02-1.06-0.27c-1.99-2.17-4.81-3.41-7.73-3.41 c-5.71,0-10.42,4.65-10.49,10.36c-0.01,0.55-0.45,0.99-1,0.99H118.6c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h11.49 c0.58-6.34,5.97-11.35,12.44-11.35c2.82,0,5.55,0.97,7.74,2.71c1.66-8.58,9.11-14.82,18.04-14.82c8.89,0,16.44,6.49,18.06,14.97 c3-4.04,7.71-6.46,12.88-6.46c8.46,0,15.46,6.62,16.05,14.95h20.38c0.55,0,1,0.45,1,1C236.68,112.84,236.23,113.29,235.68,113.29z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M384.24,131.73L384.24,131.73c-16.42-7.95-36.18-1.07-44.12,15.35l-0.17,0.35l59.47,28.77l0.17-0.35 C407.53,159.44,400.66,139.68,384.24,131.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.08,129l-8.96-4.33c-3.85-1.86-8.46,0.01-9.93,4.02l-10.68,29.18l16.33,7.9l16.25-26.49 C396.33,135.64,394.93,130.86,391.08,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M402.74,175.29l-64.14-31.03c-1.77-0.86-3.9-0.12-4.76,1.66c-0.86,1.77-0.12,3.9,1.66,4.76l64.14,31.03 c1.77,0.86,3.9,0.12,4.76-1.66C405.25,178.28,404.51,176.15,402.74,175.29z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderconstruction);
export default __webpack_public_path__ + "static/media/underconstruction.456802f7a90c980cdad3bc449c2709dd.svg";
export { ForwardRef as ReactComponent };